/* unplugin-vue-components disabled */import { render } from "./command.vue?vue&type=template&id=2c8b6bcb&scoped=true"
import script from "./command.vue?vue&type=script&lang=js"
export * from "./command.vue?vue&type=script&lang=js"

import "./command.vue?vue&type=style&index=0&id=2c8b6bcb&lang=stylus"
import "./command.vue?vue&type=style&index=1&id=2c8b6bcb&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8b6bcb"],['__file',"src/controls/command.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c8b6bcb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c8b6bcb', __exports__)) {
    api.reload('2c8b6bcb', __exports__)
  }
  
  module.hot.accept("./command.vue?vue&type=template&id=2c8b6bcb&scoped=true", () => {
    api.rerender('2c8b6bcb', render)
  })

}


export default __exports__